import { ReactNode } from "react";
import { ProjectsPage } from "./pages/ProjectsPage";
import { CustomersPage } from "./pages/CustomersPage";
import { VacancyPage } from "./pages/VacanciesPage";
import { ApplicationsPage } from "./pages/ApplicationsPage";
import { CreateApplicationPage } from "./pages/CreateApplicationPage";
import { SingleApplicationPage } from "./pages/SingleApplicationPage";
import { SingleCustomerPage } from "./pages/SingleCustomerPage";
import { CreateCustomerPage } from "./pages/CreateCustomerPage";
import { SingleProjectPage } from "./pages/SingleProjectPage";
import { CreateProjectPage } from "./pages/CreateProjectPage";
import { SingleVacancyPage } from "./pages/SingleVacancyPage";
import { CandidatePage } from "./pages/CandidatePage";
import { CreateCandidatePage } from "./pages/CreateCandidatePage";
import { SingleCandidatePage } from "./pages/SingleCandidatePage";
import { UpdateCustomerPage } from "./pages/UpdateCustomerPage";
import { UpdateProjectPage } from "./pages/UpdateProjectPage";
import { UpdateApplicationPage } from "./pages/UpdateApplicationPage";
import { UpdateCandidatePage } from "./pages/UpdateCandidatePage";
import { UpdateVacancyPage } from "./pages/UpdateVacancyPage";
import { AnnexPage } from "./pages/AnnexPage";
import { Login } from "./pages/LoginPage";
import { AnalyticsPage } from "./pages/AnalyticsPage";
import { SingleAnalyticPage } from "./pages/SingleAnalyticPage";
import { MyDivisionPage } from "./pages/MyDivisonPage";
import { AllDivisionPage } from "./pages/AllDivisionPage";
import { SingleDeparmentPage } from "./pages/SingleDeparmentPage";
import { LeadsPage } from "./pages/LeadsPage";
import { LeadsContactsPage } from "./pages/LeadsContactsPage";
import { PartnersPage } from "./pages/PartnersPage";
import { SinglePartnerPage } from "./pages/SinglePartnerPage";
import { CreatePartnerPage } from "./pages/CreatePartnerPage";
import { UpdatePartnerPage } from "./pages/UpdatePartnerPage";
import { CreateLeadPage } from "./pages/CreateLeadPage";
import { SingleLeadPage } from "./pages/SingleLeadPage";
import { UpdateLeadPage } from "./pages/UpdateLeadPage";
import { CreateLeadContactPage } from "./pages/CreateLeadContactPage";
import { UpdateLeadContactPage } from "./pages/UpdateLeadContactPage";
interface IRoute {
  path: string;
  Component: (props?: any) => ReactNode;
}

export const routes: IRoute[] = [
  {
    path: "login",
    Component: Login,
  },
  // Табличная часть заявок
  {
    path: "applications",
    Component: ApplicationsPage,
  },
  // Создание заявки
  {
    path: "applications/create",
    Component: CreateApplicationPage,
  },
  // Просмотр заявки
  {
    path: "applications/:id",
    Component: SingleApplicationPage,
  },
  {
    path: "applications/:id/edit",
    Component: UpdateApplicationPage,
  },
  // Табличная часть вакансий
  {
    path: "vacancy",
    Component: VacancyPage,
  },
  {
    path: "vacancy/:id",
    Component: SingleVacancyPage,
  },
  {
    path: "vacancy/:id/edit",
    Component: UpdateVacancyPage,
  },
  {
    path: "vacancy/:id/annex",
    Component: AnnexPage,
  },
  // Табличная часть заказчиков
  {
    path: "customers",
    Component: CustomersPage,
  },
  // Просмотр заказчика
  {
    path: "customers/:id",
    Component: SingleCustomerPage,
  },
  {
    path: "customers/:id/edit",
    Component: UpdateCustomerPage,
  },
  // Создание заказчика
  {
    path: "customers/create",
    Component: CreateCustomerPage,
  },
  // Табличная часть проектов
  {
    path: "projects",
    Component: ProjectsPage,
  },
  // Просмотр проекта
  {
    path: "projects/:id",
    Component: SingleProjectPage,
  },
  {
    path: "projects/:id/edit",
    Component: UpdateProjectPage,
  },
  // создание проекта
  {
    path: "projects/create",
    Component: CreateProjectPage,
  },
  {
    path: "candidate",
    Component: CandidatePage,
  },
  {
    path: "candidate/create",
    Component: CreateCandidatePage,
  },
  {
    path: "candidate/:id",
    Component: SingleCandidatePage,
  },
  {
    path: "candidate/:id/edit",
    Component: UpdateCandidatePage,
  },
  {
    path: "analytics",
    Component: AnalyticsPage,
  },
  {
    path: "analytics/:id",
    Component: SingleAnalyticPage,
  },
  {
    path: "my-department",
    Component: MyDivisionPage,
  },
  {
    path: "departments",
    Component: AllDivisionPage,
  },
  {
    path: "departments/:id",
    Component: SingleDeparmentPage,
  },
  {
    path: "leads",
    Component: LeadsPage,
  },
  {
    path: "leads/create",
    Component: CreateLeadPage,
  },
  {
    path: "leads/:id/edit",
    Component: UpdateLeadPage,
  },
  {
    path: "leads/:id",
    Component: SingleLeadPage,
  },
  {
    path: "leads_contacts",
    Component: LeadsContactsPage,
  },
  {
    path: "leads_contacts/create",
    Component: CreateLeadContactPage,
  },
  {
    path: "leads_contacts/:id/edit",
    Component: UpdateLeadContactPage,
  },
  {
    path: "partners",
    Component: PartnersPage,
  },
  {
    path: "partners/create",
    Component: CreatePartnerPage,
  },
  {
    path: "partners/:id",
    Component: SinglePartnerPage,
  },
  {
    path: "partners/:id/edit",
    Component: UpdatePartnerPage,
  },
];
